import TagManager from 'react-gtm-module';

export const initGTM = () => {
	const gtmId = process.env.GTM_ID;
	if (!gtmId) {
		return;
	}

	TagManager.initialize({ gtmId });
};

/**
 * Push a custom event / payload to the GTM dataLayer.
 * @param {string} event - GTM event name (must match a Trigger in GTM)
 * @param {Object} [data] - Extra fields available in GTM variables
 * @example
 * pushGTMEvent('factor_amount_submit', { amount: 100000, businessId: '123' });
 */
export const pushGTMEvent = (event, data = {}) => {
	if (!event || typeof window === 'undefined') {
		return;
	}
	TagManager.dataLayer({
		dataLayer: {
			event,
			...data,
		},
	});
};

/**
 * Push a raw object to the dataLayer (no required `event` field).
 * @param {Object} data
 */
export const pushToDataLayer = (data = {}) => {
	if (!data || typeof window === 'undefined') {
		return;
	}

	TagManager.dataLayer({ dataLayer: data });
};
